document.body.addEventListener('change', function(event) {
     let variantPath = window.location.pathname;
  let variantSearch = window.location.search;
 
  let fullPath = variantPath + variantSearch;
  
  // Now update the section with the new variant
  fetch(fullPath)
    .then(response => response.text())
    .then((data) => {
      // Parse the returned HTML to extract the section content
      const parser = new DOMParser();
      const doc = parser.parseFromString(data, 'text/html');
      const newSection = doc.getElementById('specs-content-container');
      const newSection2 = doc.getElementById('fsa-help-container');

      // Replace the existing section with the new content
      document.getElementById('specs-content-container').innerHTML = newSection.innerHTML;
      document.getElementById('fsa-help-container').innerHTML = newSection2.innerHTML;
    })
    .catch(error => console.error('Error:', error));
});



